<template>
<div class="right">
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">

                <v-dialog v-model="dialog" scrollable max-width="700px">
                    <template v-slot:activator="{ on }">
                        <v-btn class="mx-2" fab dark small color="primary">
                            <v-icon v-on="on" dark>add</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>Select Country</v-card-title>
                        <v-divider></v-divider>

                        <v-card-text>
                            <v-form ref="form">
                                <v-text-field 
                                    label="Username"
                                    persistent-hint>
                                </v-text-field>
                                <v-text-field label="First name"></v-text-field>

                                <v-text-field label="Last name"></v-text-field>

                                <v-text-field label="Phone number"></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                        <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                        <v-btn color="blue darken-1" text @click="dialog = false">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

        </template>
        <span>New user</span>
    </v-tooltip>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-btn class="mx-2" fab dark small color="success">
                <v-icon v-on="on" dark>edit</v-icon>
            </v-btn>
        </template>
        <span>Edit user</span>
    </v-tooltip>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-btn class="mx-2" fab dark small color="info">
                <v-icon v-on="on" dark>lock_open</v-icon>
            </v-btn>
        </template>
        <span>Reset password</span>
    </v-tooltip>
        <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-btn class="mx-2" fab dark small color="error">
                <v-icon v-on="on" dark>delete_outline</v-icon>
            </v-btn>
        </template>
        <span>Delete user</span>
    </v-tooltip>
</div>
</template>

<script>
export default {
    props: {
        user: Object
    },
    created() {
    },
    data () {
        return {
            dialogm1: '',
            dialog: false,
        }
    }
}
</script>